import { render, staticRenderFns } from "./EmployeeOfficialHolidaysPlanAdd.vue?vue&type=template&id=06620a24&scoped=true&"
import script from "./EmployeeOfficialHolidaysPlanAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeOfficialHolidaysPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06620a24",
  null
  
)

export default component.exports